import * as modelsGet from "../models/get";
import { getCalendarGroups } from "../api/calendarGroups";

var calendarGroups: modelsGet.ICalendarGroup[];

/**
 * Gibt alle Kalendergruppen zurück.
 * @param reload Angabe, ob die Status Einträge erneut aus der Datenbank geladen werden sollen.
 */
export async function getCalendarGroupsAsync(reload: boolean = false): Promise<modelsGet.ICalendarGroup[]>
{
    if (calendarGroups == null || reload)
    {
        calendarGroups = await getCalendarGroups();
    }

    return calendarGroups;
}